import {usePromiseTracker} from "react-promise-tracker";
import {ThreeDots} from "react-loader-spinner";
import React from "react";

const LoadingIndicator = () => {
    const { promiseInProgress } = usePromiseTracker();

    return (
        promiseInProgress &&
        <div
            style={{
                width: "20vw",
                height: "15vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex:999,
                position: "absolute",
                top: "25vh",
                left: "40vw",
                backgroundColor: "#F0F4F8",
                border: "2px solid #0E1E2F",
            }}
        >
            {/*<ThreeDots  color="#CDC57F" height="50" width="50" />*/}
            <ThreeDots  color="#0D47A1" height="50" width="50" />
        </div>
    );
}

export default LoadingIndicator;